import { RemoteGetAllProfessionalsSelectOptions } from 'data/usecases';
import { GetAllProfessionalsSelectOptionsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalsSelectOptions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllProfessionalsSelectOptions =
  (): GetAllProfessionalsSelectOptionsUseCaseInterface =>
    new RemoteGetAllProfessionalsSelectOptions(
      makeApiUrlProfessionalsSelectOptions(),
      makeAxiosHttpClient(),
    );
